/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Parkplätze`
};

const en_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Car parks`
};

const es_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Aparcamientos`
};

const fr_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Parkings`
};

const it_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Parcheggi`
};

const nl_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Parkings`
};

const pt_poi_categories__parking = /** @type {(inputs: {}) => string} */ () => {
	return `Parques de estacionamento`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_categories__parking(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_categories__parking", locale)
	if (locale === "de") return de_poi_categories__parking(inputs)
	if (locale === "en") return en_poi_categories__parking(inputs)
	if (locale === "es") return es_poi_categories__parking(inputs)
	if (locale === "fr") return fr_poi_categories__parking(inputs)
	if (locale === "it") return it_poi_categories__parking(inputs)
	if (locale === "nl") return nl_poi_categories__parking(inputs)
	return pt_poi_categories__parking(inputs)
};